import React from 'react';
import { PrinterIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './ui/SectionHeading';
import { Carousel } from './ui/Carousel';
import { plantillas } from '../data/landing';
export function PlantillasCarrusel() {
  return <section className="w-full bg-white py-12 sm:py-20" aria-labelledby="plantillas-titulo" data-id="element-143" data-mp="3jl3yavsemls">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-144" data-mp="7kold1thgqp4">
        <Reveal data-id="element-145" data-mp="373ftcudeo1yq">
          <SectionHeading eyebrow="Biblioteca de patrones" title={<span id="plantillas-titulo" data-id="element-147" data-mp="3c0psj1qljrzr">
                No empezás desde una hoja en blanco
              </span>} subtitle="Elegí un diseño, imprimilo y empezá a bordar." data-id="element-146" data-mp="373zcufipeyev" />
        </Reveal>
      </div>

      <Reveal delay={0.1} className="mt-8" data-id="element-148" data-mp="3ku2pcers7dr4">
        <Carousel ariaLabel="Carrusel de plantillas incluidas" data-id="element-149" data-mp="3kuuf38yp6h9h">
          {plantillas.map(plantilla => <figure key={plantilla.id} className="h-full overflow-hidden rounded-3xl border border-rosa-100 bg-crema shadow-tarjeta" data-id="element-150" data-mp="2obemp5ue37er">
              <div className="aspect-[4/5] w-full overflow-hidden bg-arena" data-id="element-151" data-mp="2v6tact1j7hy3">
                <img src={plantilla.imagen} alt={`Plantilla imprimible: ${plantilla.titulo}`} loading="lazy" className="h-full w-full object-cover" data-id="element-152" data-mp="2v8vyf7j4j106" />
              </div>
              <figcaption className="px-4 py-3" data-id="element-153" data-mp="2lfowxxri855d">
                <span className="font-sans text-[11px] font-bold uppercase tracking-[0.18em] text-terracota" data-id="element-154" data-mp="2ghwu48pbmyme">
                  {plantilla.categoria}
                </span>
                <p className="mt-1 font-serif text-lg text-borgona" data-id="element-155" data-mp="2bgpmqar3c1g9">
                  {plantilla.titulo}
                </p>
              </figcaption>
            </figure>)}
        </Carousel>
      </Reveal>

      <div className="mx-auto mt-6 max-w-5xl px-5 text-center sm:px-8" data-id="element-156" data-mp="22k8bz8mn25l1">
        <Reveal delay={0.15} data-id="element-157" data-mp="1xklwesjc8d92">
          <p className="inline-flex items-center gap-3 rounded-full border border-rosa-200 bg-rosa-50 px-5 py-3 font-sans text-base font-bold text-borgona sm:text-lg" data-id="element-158" data-mp="1xldse4gukczv">
            <PrinterIcon className="h-5 w-5 text-frambuesa" aria-hidden="true" data-id="element-159" data-mp="3rxlj15m4y7pu" />
            +100 patrones listos para imprimir
          </p>
        </Reveal>
      </div>
    </section>;
}